// extracted by mini-css-extract-plugin
export default {"card":"game-card_card__WX8Hk","info":"game-card_info__x9mAa","card__picture":"game-card_card__picture__M9kqG","info__players-count":"game-card_info__players-count__lwl7y"};